import React from 'react';
import { bool, arrayOf, number, shape } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { withViewport } from '../../util/uiHelpers';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import {
  Page,
  LayoutSingleColumn,
  Footer
} from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import HubspotForm from "react-hubspot-form";
import css from './ContactUsPage.module.css';


const ContactUsPageComponent = props => {

  const {scrollingDisabled} = props;
 
  return (
    <Page
      title="Contact us"
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactUsPage',
        name: "Contact us",
      }}
    >
      <LayoutSingleColumn
        className={css.page}
        topbar={<TopbarContainer currentPage="ContactUsPage" />}
        footer={<Footer />}
      >
        <div className={css.root}>
          <h1 className={css.title}>
            <FormattedMessage id="ContactUsPage.title" />
          </h1>

          <div className={css.content}>
            <HubspotForm
                portalId={41489931}
                formId={'16400406-3aad-4875-b502-821eb50350cd'}
                onSubmit={(form) => console.log('Submit!')}
                onReady={(form) => console.log('Form ready!')}
                loading={<div>Loading...</div>}
                cssRequired='
                  input.hs-input:not([type=file]) {width: 100%; background-color: #fff;}
                  input.hs-input {width: 100%; background-color: #fff;border-color: #d8dce6;}
                  input.hs-input.error {border-color: #C96156;}
                  .inputs-list label.hs-error-msg {margin-top: 10px;font-size: 16px;}
                  .hs_email.hs-email {margin-bottom: 0;}
                  input.hs-button {width:100%;background-color: #45A8D4;border-color:#45A8D4;min-height:56px;font-size: 16px; }
                  input.hs-button:hover {background-color: #093254; border-color:#093254 }
                  input.hs-button:focus {background-color: #093254; border-color:#093254 }
                  .hubspot-link__container {display:none}
                  .hs_email.hs-email {margin-bottom: 18px;}
                  textarea.hs-input.hs-fieldtype-textarea {width: 100%;min-height:50px;background-color: #fff; resize:vertical;}
                  .submitted-message {text-align: center; margin: 100px 0;font-weight: 600;font-size: 20px;}
                '
              />
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

ContactUsPageComponent.defaultProps = {
  currentUser: null,
};

ContactUsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
};

const mapStateToProps = state => {

  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

const ContactUsPage = compose(
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(ContactUsPageComponent);

export default ContactUsPage;
